/**
 * Generated by orval v7.8.0 🍺
 * Do not edit manually.
 * TopTopTime API
 * <:3 )~~~~    =^.^=
 * OpenAPI spec version: 0.0.1
 */

/**
 * When a date move (updates.anchorDate) affects a series / this-and-following that has future bookings: 'move' shifts the booked occurrences to the new dates and notifies the bookers; 'leave' (default) keeps booked occurrences on their original dates while the unbooked ones move. Ignored for scope=occurrence (a booked occurrence move is rejected).
 */
export enum UpdateSlotBodyBookedStrategy {
  move = 'move',
  leave = 'leave'
}
